// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/app.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-none.d-md-flex.flex-column.h-100.position-relative {
  background-color: #101413 !important;
  border-right: 1px solid rgba(172, 203, 195, 0.12);
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.sidebar-expanded .overflow-auto,
.sidebar-collapsed .overflow-auto {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.sidebar-logo-wrap {
  padding-top: 8px;
  padding-bottom: 0;
  margin-bottom: 0;
}

.sidebar-nav-wrap {
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.sidebar-link {
  display: flex;
  align-items: center;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9375rem;
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease;
  color: #accbc3;
  margin: 0 6px;
  padding: 10px 14px;
}

.sidebar-expanded .sidebar-link {
  padding: 10px 14px;
}

.sidebar-icon {
  font-size: 1.05rem;
  color: #accbc3;
  transition: color 0.2s ease;
  flex-shrink: 0;
}

.sidebar-link.active {
  background-color: #1f7c50;
  color: #fff;
  font-weight: 600;
  border-left: 3px solid #1f7c50;
  padding-left: 11px;
}
.sidebar-link.active .sidebar-icon {
  color: #fff;
}

.logocomply {
  width: 90%;
  height: auto;
  max-height: 150px;
  max-width: 400px;
  object-fit: contain;
  display: block;
  padding: 4px 6px;
}

.sidebar-expanded .overflow-auto::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.sidebar-expanded .overflow-auto::-webkit-scrollbar-track {
  background: #101413;
}
.sidebar-expanded .overflow-auto::-webkit-scrollbar-thumb {
  background: #1f7c50;
  border-radius: 4px;
}
.sidebar-expanded .overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #07ffa9;
}

.logoCert{
  width: 60%;
  height: 60%;
  padding-left: 10px;
  padding-top: 27px;
  padding-bottom: 5px;
}

.sidebar-collapsed .sidebar-icon {
  font-size: 1.25rem;
  padding-bottom: 6px;
}

.sidebar-link.active .sidebar-icon {
  color: var(--color-mint);
}

/* Hover effect */
.sidebar-link:hover {
  background-color: rgba(172, 203, 195, 0.08);
  color: #accbc3;
  text-decoration: none;
}
.sidebar-link:hover .sidebar-icon {
  color: #accbc3;
}

/* Keep active state green when hovering */
.sidebar-link.active:hover {
  background-color: #1f7c50;
  color: #fff;
  text-decoration: none;
}
.sidebar-link.active:hover .sidebar-icon {
  color: #fff;
}
/* When sidebar is collapsed */
.sidebar-collapsed .sidebar-link {
  justify-content: center;
  padding: 10px;
  margin: 0 4px;
}

.sidebar-collapsed .sidebar-link span {
  display: none;
}

`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,uDAAuD;EACvD,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import '../../styles/app';\r\n\r\n.d-none.d-md-flex.flex-column.h-100.position-relative {\r\n  background-color: #101413 !important;\r\n  border-right: 1px solid rgba(172, 203, 195, 0.12);\r\n  padding-bottom: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.sidebar-expanded .overflow-auto,\r\n.sidebar-collapsed .overflow-auto {\r\n  padding-bottom: 0 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.sidebar-logo-wrap {\r\n  padding-top: 8px;\r\n  padding-bottom: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.sidebar-nav-wrap {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.sidebar-link {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  font-size: 0.9375rem;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s ease, color 0.2s ease;\r\n  color: #accbc3;\r\n  margin: 0 6px;\r\n  padding: 10px 14px;\r\n}\r\n\r\n.sidebar-expanded .sidebar-link {\r\n  padding: 10px 14px;\r\n}\r\n\r\n.sidebar-icon {\r\n  font-size: 1.05rem;\r\n  color: #accbc3;\r\n  transition: color 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-link.active {\r\n  background-color: #1f7c50;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  border-left: 3px solid #1f7c50;\r\n  padding-left: 11px;\r\n}\r\n.sidebar-link.active .sidebar-icon {\r\n  color: #fff;\r\n}\r\n\r\n.logocomply {\r\n  width: 90%;\r\n  height: auto;\r\n  max-height: 150px;\r\n  max-width: 400px;\r\n  object-fit: contain;\r\n  display: block;\r\n  padding: 4px 6px;\r\n}\r\n\r\n.sidebar-expanded .overflow-auto::-webkit-scrollbar {\r\n  width: 4px;\r\n  height: 4px;\r\n}\r\n.sidebar-expanded .overflow-auto::-webkit-scrollbar-track {\r\n  background: #101413;\r\n}\r\n.sidebar-expanded .overflow-auto::-webkit-scrollbar-thumb {\r\n  background: #1f7c50;\r\n  border-radius: 4px;\r\n}\r\n.sidebar-expanded .overflow-auto::-webkit-scrollbar-thumb:hover {\r\n  background: #07ffa9;\r\n}\r\n\r\n.logoCert{\r\n  width: 60%;\r\n  height: 60%;\r\n  padding-left: 10px;\r\n  padding-top: 27px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.sidebar-collapsed .sidebar-icon {\r\n  font-size: 1.25rem;\r\n  padding-bottom: 6px;\r\n}\r\n\r\n.sidebar-link.active .sidebar-icon {\r\n  color: var(--color-mint);\r\n}\r\n\r\n/* Hover effect */\r\n.sidebar-link:hover {\r\n  background-color: rgba(172, 203, 195, 0.08);\r\n  color: #accbc3;\r\n  text-decoration: none;\r\n}\r\n.sidebar-link:hover .sidebar-icon {\r\n  color: #accbc3;\r\n}\r\n\r\n/* Keep active state green when hovering */\r\n.sidebar-link.active:hover {\r\n  background-color: #1f7c50;\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n.sidebar-link.active:hover .sidebar-icon {\r\n  color: #fff;\r\n}\r\n/* When sidebar is collapsed */\r\n.sidebar-collapsed .sidebar-link {\r\n  justify-content: center;\r\n  padding: 10px;\r\n  margin: 0 4px;\r\n}\r\n\r\n.sidebar-collapsed .sidebar-link span {\r\n  display: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
